export default __webpack_public_path__ + "static/media/trenza-castano.4947b6ef.png";